import { useQuery } from "@tanstack/react-query";
import { HiverAnalyticsAxios } from "../helpers";

const SM_CONVERSATION_QUERY_KEY = "SM_CONVERSATION_QUERY_KEY";
const getSmMailsApi = ({ smId, payload }) =>
  HiverAnalyticsAxios({
    url: `/${smId}/report/conversations/active`,
    type: "POST",
    params: payload,
  });

export const useGetSmConversations = ({ smId, payload }) => {
  return useQuery({
    queryKey: [SM_CONVERSATION_QUERY_KEY, smId, payload],
    queryFn: () => getSmMailsApi({ smId, payload }),
  });
};